import { SchemaStore } from '@sensenet/default-content-types';

/**
 * The default Sense/Net OData Service token (odata.svc)
 */
export const DEFAULT_SERVICE_TOKEN = 'odata.svc';
export const defaultRepositoryConfiguration = {
  chunkSize: 1000000,
  defaultEnableAutofilters: false,
  defaultEnableLifespanfilter: false,
  defaultInlineCount: 'allpages',
  defaultMetadata: 'no',
  defaultSelect: ['DisplayName', 'Description', 'Icon'],
  defaultTop: 10000,
  oDataToken: DEFAULT_SERVICE_TOKEN,
  repositoryUrl: '',
  requiredSelect: ['Id', 'Path', 'Name', 'Type'],
  schemas: SchemaStore,
  identityServerUrl: ''
};
//# sourceMappingURL=RepositoryConfiguration.js.map